import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import config from '../../config';
import { hasParentWithClassName } from './SearchMap.helpers.js';
import SearchMapWithGoogleMap, {
  LABEL_HANDLE,
  INFO_CARD_HANDLE,
  getMapBounds,
  getMapCenter,
  fitMapToBounds,
  isMapsLibLoaded,
} from './SearchMapWithGoogleMap';
import ReusableMapContainer from './ReusableMapContainer';

import css from './SearchMap.css';

const REUSABLE_MAP_HIDDEN_HANDLE = 'reusableMapHidden';

export const SearchMapComponent = ({
  className = null,
  rootClassName = null,
  mapRootClassName = null,
  reusableContainerClassName = null,
  bounds = null,
  center = null,
  location,
  zoom = 11,
  messages,
  pagination,
  onCloseMap,
  providers,
  history,
  updateBounds,
}) => {
  let mapRef = null;
  const [infoCardOpen, setInfoCardOpen] = useState(null);
  const [mapReattachmentCount, setMapReattachmentCount] = useState(0);
  const classes = classNames(rootClassName || css.root, className);

  const forceUpdateHandler = () => {
    // Update global reattachement count
    window.mapReattachmentCount += 1;
    // Initiate rerendering
    setMapReattachmentCount( window.mapReattachmentCount );
  };

  const onMapClicked = (e) => {
    // Close open listing popup / infobox, unless the click is attached to a price label
    const labelClicked = hasParentWithClassName(e.nativeEvent.target, LABEL_HANDLE);
    const infoCardClicked = hasParentWithClassName(e.nativeEvent.target, INFO_CARD_HANDLE);
    if (infoCardOpen != null && !labelClicked && !infoCardClicked) {
      setInfoCardOpen( null );
    }
  }

  const onMapLoadHandler = (map) => {
    mapRef = map;

    if (mapRef && mapReattachmentCount === 0) {
      // map is ready, let's fit search area's bounds to map's viewport
      fitMapToBounds(mapRef, bounds, { padding: 0, isAutocompleteSearch: true });
    }
  }

    useEffect(() => {
      if (typeof window !== 'undefined') {
        if (window.mapReattachmentCount) {
          setMapReattachmentCount( window.mapReattachmentCount);
        } else {
          window.mapReattachmentCount = 0;
        }
      }
    }, []);

    return isMapsLibLoaded() ? (
      <ReusableMapContainer
        className={reusableContainerClassName}
        reusableMapHiddenHandle={REUSABLE_MAP_HIDDEN_HANDLE}
        onReattach={forceUpdateHandler}
        messages={messages}
      >
        <div className={css.productInfo}>
          <FormattedMessage
            id="SearchMap.mobileProductInfo"
            values={{ count: pagination ? pagination.totalItems : 0 }}
          />
        </div>
        <SearchMapWithGoogleMap
          containerElement={
            <div id="search-map-container" className={classes} onClick={onMapClicked} />
          }
          mapElement={<div className={mapRootClassName || css.mapRoot} />}
          bounds={bounds}
          center={center}
          location={location}
          infoCardOpen={infoCardOpen}
          onMapLoad={onMapLoadHandler}
          onCloseMap={onCloseMap}
          zoom={zoom}
          providers={providers}
          history={history}
          updateBounds={updateBounds}
        />
      </ReusableMapContainer>
    ) : (
      <div className={classes} />
    );
}

const SearchMap = withRouter(SearchMapComponent);

SearchMap.getMapBounds = getMapBounds;
SearchMap.getMapCenter = getMapCenter;

export default SearchMap;
